import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import YesNoDescriptionInputGroup from '../../common/YesNoDescriptionInputGroup';
import './ResponsibilitiesTab.scss';
var responsibilityExampleText = "This has been a part of my responsibilities over my career.\nMost recently, I was responsible for managing a 50 site study.\nMy responsibilities included creation of a project plan, obtaining the CMO and CEO\u2019s\napproval of the timelines and budget, and executing to that plan.\nI typically use Microsoft Project to generate the project plan but am happy to use whatever\nthe company prefers.";
var negativeResponsibilityExampleText = "No, I have not specifically been a project manager\non late phase (phase III/IV) trials. Most of my work has been in phase I-II\ntrials as well as translational research.";
function ResponsibilitiesTab(_ref) {
  var project = _ref.project,
    proposal = _ref.proposal,
    onFormChange = _ref.onFormChange,
    errors = _ref.errors;
  var responsibility_areas = project.responsibility_areas;
  var displayedExampleText = responsibilityExampleText;
  if (proposal.responsibility_areas) {
    displayedExampleText = proposal.responsibility_areas.some(function (p) {
      return p.selected === 'No';
    }) ? negativeResponsibilityExampleText : responsibilityExampleText;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "responsibilities-tab"
  }, responsibility_areas.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "no-requirements-placeholder"
  }, "The Employer has not specified any requirements."), responsibility_areas.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "mb-3 responsibilities"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "Can you fulfill the following responsibilities?",
    location: "proposal-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-25 ms-3"
  }, /*#__PURE__*/React.createElement(YesNoDescriptionInputGroup, {
    options: responsibility_areas,
    formKey: "responsibility_areas",
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('responsibility_areas', val);
    },
    errors: errors,
    value: proposal.responsibility_areas,
    requiredDescriptionValues: ['No', 'Yes'],
    exampleText: displayedExampleText,
    textAreaPrompt: "Provide details about your experience related to this responsibility. It is important to be thorough to ensure potential employers can efficiently evaluate fit. Note: minimum of 50 characters"
  })))));
}
ResponsibilitiesTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired
};
export default ResponsibilitiesTab;